/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { OperationalProgressDto } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Task Completion
 */
export const getIntelligenceProjectProjectIdTaskCompletion = (
  projectId: number,
  signal?: AbortSignal,
) => {
  return customInstance<OperationalProgressDto>({
    url: `/intelligence/project/${projectId}/task-completion`,
    method: "GET",
    signal,
  });
};

export const getGetIntelligenceProjectProjectIdTaskCompletionInfiniteQueryKey =
  (projectId?: number) => {
    return [
      "infinite",
      `/intelligence/project/${projectId}/task-completion`,
    ] as const;
  };

export const getGetIntelligenceProjectProjectIdTaskCompletionQueryKey = (
  projectId?: number,
) => {
  return [`/intelligence/project/${projectId}/task-completion`] as const;
};

export const getGetIntelligenceProjectProjectIdTaskCompletionInfiniteQueryOptions =
  <
    TData = InfiniteData<
      Awaited<ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>>
    >,
    TError = void,
  >(
    projectId: number,
    options?: {
      query?: Partial<
        UseInfiniteQueryOptions<
          Awaited<
            ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetIntelligenceProjectProjectIdTaskCompletionInfiniteQueryKey(
        projectId,
      );

    const queryFn: QueryFunction<
      Awaited<ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>>
    > = ({ signal }) =>
      getIntelligenceProjectProjectIdTaskCompletion(projectId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!projectId,
      staleTime: 10000,
      refetchOnWindowFocus: false,
      ...queryOptions,
    } as UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>>,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetIntelligenceProjectProjectIdTaskCompletionInfiniteQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>>
  >;
export type GetIntelligenceProjectProjectIdTaskCompletionInfiniteQueryError =
  void;

export function useGetIntelligenceProjectProjectIdTaskCompletionInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>>
  >,
  TError = void,
>(
  projectId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
          >,
          TError,
          Awaited<
            ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceProjectProjectIdTaskCompletionInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
          >,
          TError,
          Awaited<
            ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceProjectProjectIdTaskCompletionInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Task Completion
 */

export function useGetIntelligenceProjectProjectIdTaskCompletionInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetIntelligenceProjectProjectIdTaskCompletionInfiniteQueryOptions(
      projectId,
      options,
    );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetIntelligenceProjectProjectIdTaskCompletionQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntelligenceProjectProjectIdTaskCompletionQueryKey(projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>>
  > = ({ signal }) =>
    getIntelligenceProjectProjectIdTaskCompletion(projectId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntelligenceProjectProjectIdTaskCompletionQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>>
  >;
export type GetIntelligenceProjectProjectIdTaskCompletionQueryError = void;

export function useGetIntelligenceProjectProjectIdTaskCompletion<
  TData = Awaited<
    ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
  >,
  TError = void,
>(
  projectId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
          >,
          TError,
          Awaited<
            ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceProjectProjectIdTaskCompletion<
  TData = Awaited<
    ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
          >,
          TError,
          Awaited<
            ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceProjectProjectIdTaskCompletion<
  TData = Awaited<
    ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Task Completion
 */

export function useGetIntelligenceProjectProjectIdTaskCompletion<
  TData = Awaited<
    ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceProjectProjectIdTaskCompletion>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetIntelligenceProjectProjectIdTaskCompletionQueryOptions(
      projectId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
